import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboGenericoModule} from './combo-generico/combo-generico.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ComboGenericoModule
    ],
    exports: [
        ComboGenericoModule
    ]
})
export class SharedComponentsModule {
}
